export const LABEL_MAX_WIDTH = 130;
export const TEXT_ADJUST_Y = 12;
export const ROW_HEIGHT = 13;
export const PADDING_Y = 7;
export const PADDING_X = 25;
export const RECT_OPACITY = 0.8;
export const X_AXIS_HEIGHT = 15;
export const DEFAULT_FLAG_SIZE = 16;
export const SCALE_TICKS = 4;
export const ICON_PLUS_PADDING = 22;
export const EXCHANGE_PADDING = 20;
export const AXIS_LEGEND_PADDING = 15;
